import { cn } from '@/lib/utils';
import { CircleCheck, type LucideProps } from 'lucide-react';

export const FilledCircleCheck = ({ className, ...props }: LucideProps) => (
  <CircleCheck {...props} className={cn('fill-current stroke-white', className)} />
);
